/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { typedDependencies } from './dependenciesTyped.generated';
import { createString } from '../../factoriesAny.js';
export var stringDependencies = {
  typedDependencies: typedDependencies,
  createString: createString
};